import styled from "@emotion/styled";
import classNames from "classnames";
import React, { ReactElement } from "react";
import { withDefault } from "../../utils/withDefault";
import Spinner from "./Spinner";
import { TextColor } from "./ThemeTypes";

export interface AppButtonProps
  extends React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  color?: "primary" | "success" | "danger" | "white" | "black" | "sexy" | "success-dark";
  variant?: "filled" | "outline" | "soft" | "link" | "round";
  size?: "extra-small" | "small" | "default" | "large";
  block?: boolean;
  textColor?: TextColor;
  children?: React.ReactNode;
  isLoading?: boolean;
}

const BaseButton = (props: AppButtonProps, ref: React.Ref<HTMLButtonElement>): ReactElement => {
  const { color, variant, size, textColor, disabled, isLoading, block, ...buttonProps } = props;

  return (
    <button
      ref={ref}
      {...buttonProps}
      className={classNames(props.className, "AppButton")}
      disabled={(disabled ?? isLoading) === true}
      data-variant={withDefault(variant, "filled")}
      data-color={withDefault(color, "primary")}
      data-size={withDefault(size, "default")}
      data-text-color={textColor}
      data-block={block === true}
    >
      {isLoading === true ? <BaseButton.Spinner size={16} /> : null}
      {props.children}
    </button>
  );
};

BaseButton.Spinner = styled(Spinner)`
  margin-inline-end: 8px;
`;

export const AppButton = React.forwardRef(BaseButton);
